import React, { Fragment, useContext, useEffect } from "react";
import { Router, NavLink, Switch, Route } from "react-router-dom";
import Games from "./Games";
import Home from "./Home";
import Profile from "./Profile";
import Preferences from "./Preferences";
import Invites from "./Invites";
import history from "../history";
import { Context as AuthContext } from "../context/AuthContext";
import { Provider as GamesProvider } from "../context/GamesContext";

const Account = ({ match }) => {
  const {
    state,
    tryLocalSignin,
    signout,
    update,
    updatePassword,
    updateEmailPreferences,
    clearErrorMessage,
  } = useContext(AuthContext);
  const { user, errorMessage } = state;
  useEffect(() => {
    tryLocalSignin();
  }, []);

  const logoutFunction = (e) => {
    signout();
  };

  return (
    <Fragment>
      {user ? (
        <div className="pt-10 px-10 h-screen w-screen flex flex-col divide-y-2 divide-coolGray-400 fixed">
          <div className="h-auto w-full flex flex-row justify-between">
            <div className="text-3xl text-blue-500 font-semibold mb-2">
              Hello, {user.first_name}
            </div>
            <div className="flex">
              {/* <div className="flex flex-row items-center rounded-lg"> */}
              {/* <div className="w-auto py-2 pl-2 text-emerald-400 text-lg font-medium uppercase cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-400">
                  Buy Credits
                </div>
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="text-coolGray-400 transform -rotate-12"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div> */}
            </div>
          </div>
          <div className="flex flex-row h-screen p-2 space-x-5 overflow-hidden divide-x">
            <div className="w-1/8 h-full py-3 pr-5">
              <ul className="flex flex-col">
                <li className="">
                  <NavLink
                    to="/dashboard/home"
                    className="text-2xl w-full flex items-center justify-apart py-3 hover:underline"
                    activeClassName="text-blue-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6 mr-3"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                      />
                    </svg>
                    Home
                  </NavLink>
                </li>
                {/* <Link to="/dashboard/games">Games</Link> */}
                <li className="">
                  <NavLink
                    to="/dashboard/profile"
                    className="text-2xl w-full flex items-center justify-apart py-3 hover:underline"
                    activeClassName="text-blue-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6 mr-3"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    Profile
                  </NavLink>
                </li>
                <li>
                  <div className="text-2xl w-full flex items-center justify-apart py-3 hover:underline">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6 mr-3"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                      />
                    </svg>
                    <button
                      className="whitespace-nowrap"
                      onClick={(e) => logoutFunction()}
                    >
                      Log out
                    </button>
                  </div>
                </li>
                {/* <Link to="/dashboard/preferences">Preferences</Link>
                <Link to="/dashboard/invites">Invites</Link> */}
              </ul>
            </div>
            <div className="w-full h-full overflow-y-auto">
              <GamesProvider>
                <Router history={history}>
                  <Switch>
                    <Route
                      exact
                      path={`${match.url}/home`}
                      render={(props) => <Home {...props} user={user} />}
                    />
                    <Route
                      exact
                      path={`${match.url}/games`}
                      render={(props) => <Games {...props} user={user} />}
                    />
                    <Route
                      exact
                      path={`${match.url}/profile`}
                      render={(props) => (
                        <Profile
                          {...props}
                          user={user}
                          errorMessage={errorMessage}
                          update={update}
                          updatePassword={updatePassword}
                          updateEmailPreferences={updateEmailPreferences}
                          clearErrorMessage={clearErrorMessage}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`${match.url}/preferences`}
                      component={Preferences}
                    />
                    <Route
                      exact
                      path={`${match.url}/invites`}
                      component={Invites}
                    />
                  </Switch>
                </Router>
              </GamesProvider>
            </div>
          </div>
        </div>
      ) : (
        <p>loading...</p>
      )}
    </Fragment>
  );
};

export default Account;
